/**
 * Route for `campaign-grouping`. Registered via createRoute; root wires into
 * router.tsx post-merge. Breadcrumb label "Campaign Groups" is auto-derived
 * from the route path segment.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignGroupingPage } from "../features/campaign-grouping/CampaignGroupingPage";

export const campaignGroupingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-grouping",
	component: CampaignGroupingPage,
});

export default campaignGroupingRoute;
